import { Component, inject } from '@angular/core';
import { RouterOutlet } from '@angular/router';
import { NgxMuvstok, NgxMuvstokService } from '@muvstok/ngx-muvstok';
import { environment } from '../environments/environment';
import { loadMessages } from 'devextreme/localization';
import { locale } from 'moment';
import ptMessages from 'devextreme/localization/messages/pt.json';
import config from 'devextreme/core/config';
import { licenseKey } from '../devextreme-license';
import { ConfigService } from './core/services/config.service';
import { LayoutConfigService } from './core/services/layout-config.service';

@Component({
  selector: 'app-root',
  imports: [RouterOutlet, NgxMuvstok],
  templateUrl: './app.html',
})
export class App {
  private configService: ConfigService = inject(ConfigService);
  private layoutConfig: LayoutConfigService = inject(LayoutConfigService);
  private muvstokService: NgxMuvstokService = inject(NgxMuvstokService);

  constructor() {
    const baseUrlMuvStok = environment.baseUrlMuvStok;
    this.layoutConfig.setTheme(this.configService.config.theme);

    this.muvstokService.initialize({
      urlMuvstokApi: baseUrlMuvStok,
      validActions: this.configService.validActions,
      defaultAutomakerId: this.configService.config.defaultAutomakerId,
      actions: this.configService.actions,
    });

    loadMessages(ptMessages);
    locale('pt');
    config({ defaultCurrency: 'BRL', licenseKey });
  }
}
